<template>
  <router-view></router-view>
</template>
<script>
import Vuex from 'vuex'

const worklistStore = Vuex.createNamespacedHelpers('Worklist')

export default {
  name: 'BtWorkList',
  components: {
  },
  data: () => ({
    title: 'Approval Business Trip Realization'
  }),
  methods: {
    ...worklistStore.mapActions({
      getActiveWorklistById: 'getActiveWorklistById'
    }),
    loadData (e) {
      this.getActiveWorklistById({vueinstance: this, id: this.$route.params.worklistid})
        .then(res => {
          this.$showApprovalAction({vueinstance: this, actions: res.obj})
          this.$router.push({name: res.obj.routeName, params: {...res.obj.params, editable: res.body.editable}})
        })
        .catch(() => {
          this.$setApprovalNotification({vueinstance: this, status: true, message: `Worklist Not Found`})
          this.$router.push({path: '/'})
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loadData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bt-worklist/index.vue